var React = require('react');

function IconCross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 1L1 13M1 1l12 12","fill":"none","fillRule":"evenodd","stroke":"#383535","strokeLinejoin":"round","strokeWidth":"2"}));
}

IconCross.displayName = "IconCross";

IconCross.defaultProps = {"width":"14","height":"14"};

module.exports = IconCross;

IconCross.default = IconCross;
